import { createSelector } from 'reselect';
export var selectState = function (state) { return state.get('articleStack'); };
export var selectAll = createSelector(selectState, function (state) {
    return state.get('data');
});
